import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import RecurringForm from 'components/form/RecurringForm/component';

const enhance = compose(withTranslation('Recurring'));

export default enhance(RecurringForm);
